/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_OrderInputs */

const vi_dashboard_driver_next_stop_order = /** @type {(inputs: Dashboard_Driver_Next_Stop_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng`)
};

/**

* @param {Dashboard_Driver_Next_Stop_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_order = /** @type {((inputs?: Dashboard_Driver_Next_Stop_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_order(inputs)
});